import React from 'react';
import {ImageRewrite} from './util.js';
import Dialog from 'react-bootstrap-dialog';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as listingActions from 'actions/listings';
import { getFormatedCurrency, getFormatedNumber } from '../components/util';
import { Link } from 'react-router-dom';
import NoPropertyPhoto from '../img/no-property-photo.png';

class PropertiesCompare extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            collapsed: false 
        };
        this.onDeleteCompareClicked = this.onDeleteCompareClicked.bind(this);
        this.format = this.format.bind(this);
        this.collapse = this.collapse.bind(this);
    }

    mapping = {
        MN: 'MLS no.',
        TLC: 'TLC',
        LP: 'List price',
        FA: 'Address'
    }

    collapsed = {
        LA: 'Sqft', // collapsible
        GR: 'Garages',
        YR: 'Year built',
        PT: 'Architecture'
    }

    onDeleteCompareClicked = (listingId) => {
        this.props.listingActions.removeListing('compare', listingId);
    }

    format = (key, value) => {
        switch (key) {
            case 'LP':
            case 'TLC':
                return (<div className='compare_accent'>{getFormatedCurrency(value)}</div>);
            case 'MN':
                return (<div className='compare_accent'>{ value }</div>);
            case 'FA':
                var breaks = value.split('\n');
                var ret = breaks.map(function (line) {
                    return (<p>{line}</p>);
                })
                return ret;
            case 'LA':
                return getFormatedNumber(value);
            default:
                return value;
        }
    }

    collapse = () => {
        this.setState({collapsed: !this.state.collapsed})
    }

    render() {
        const { properties } = this.props;
        const mapping = this.mapping;
        const collapsed = this.collapsed;
        return (
            <div className="compare_mb_table">
                <table className='table compare comparison'>
                    <tbody>
                        <tr>
                            <th></th>
                            {
                                properties.map((property, index) => {
                                    var imgSrc
                                    if (!property.Photos || !property.Photos.length) {
                                        if (property.INDXR)
                                            imgSrc = ImageRewrite(property.INDXR.split('|')[0], true);
                                        else
                                            imgSrc = NoPropertyPhoto;
                                    }
                                    else 
                                        imgSrc = ImageRewrite(property.Photos[0], true);
                                    var FA = `${property.SA} ${property.CT}, ${property.ST} ${property.PC}`;
                                    return (<td key={index}>
                                        <div key={index}>
                                            <Link onClick={() => this.props.closeDialog()} to={`${this.props.purlPrefix.url}/propertydetail/` + property.Id + '/' + (property.SA ? property.SA.split(' ').join('-') : property.MN) + (property.CT ? '_' + property.CT.split(' ').join('-') : '') + (property.ST ? '_' + property.ST.split(' ').join('-') : '') + (property.PC ? '_' + property.PC.split(' ').join('-') : '')} >
                                                <img src={ imgSrc } alt={FA} className="compare-img" />
                                            </Link>
                                        </div>
                                    </td>)
                                })}
                        </tr>
                        {Object.keys(mapping).map(function (key) {
                            return (<tr>
                                <th>
                                    {mapping[key]}
                                </th>
                                {properties.map((property, index) => {
                                    var FA = `${property.SA}\n${property.CT}, ${property.ST}\n${property.PC}`;
                                    var propertyWithAddress = { ...property, FA };
                                    return <td key={index}>{this.format(key, propertyWithAddress[key])}</td>
                                })}
                            </tr>)
                        }, this)}
                        <tr>
                            <th>
                                <i className={this.state.collapsed ? "fa fa-arrow-down" : "fa fa-arrow-up"}
                                    onClick={() => this.collapse()}></i>
                            </th>
                            {properties.map((property, index) => { return <td></td> })}
                        </tr>
                        {Object.keys(collapsed).map(function (key) {
                            return (<tr className={this.state.collapsed ? "compare-collapsed": "compare-collapsible" }>
                                <th>
                                    {collapsed[key]}
                                </th>
                                {properties.map((property, index) => {
                                    return <td key={index}>{this.format(key, property[key])}</td>
                                })}
                            </tr>)
                        }, this)}
                        <tr>
                            <th>
                            </th>
                            {properties.map((property, index) =>
                                <td key={index}>
                                    <button id="pop_remove_bt" className="tru-btn tru-btn-theme" onClick={() => this.onDeleteCompareClicked(property.Id)}>
                                        Remove
                                </button>
                                </td>
                            )}
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

export class PropertiesCompareAlert extends React.Component {
    constructor(props) {
        super(props);
        this.onDeleteCompareClicked = this.onDeleteCompareClicked.bind(this);
        this.state = {
            dialogIsOpen: false
        }
    }
    openCompareDialog(_properties) {
        this.setState({ dialogIsOpen: true })
        Dialog.setOptions({
            defaultCancelLabel: 'Close',
            primaryClassName: 'compare'
        });
        let propListings = this.props.listings
        let compareListings = _properties.listings.reduce((obj, item) => Object.assign(obj, {[item.Id]: item}) ,{});
        let allListings = {...propListings, ...compareListings }
        this.refs.dialogRef.show({
            body: <PropertiesCompare properties={_properties.ids.map(id => allListings[id])} listingActions={this.props.listingActions} closeDialog={() => {this.refs.dialogRef.hide();this.setState({ dialogIsOpen: false })}} purlPrefix={this.props.purlPrefix} />,
            bsSize: 'large',
            title: 'Property comparison',
            actions: [
                Dialog.CancelAction(() => {
                    this.setState({ dialogIsOpen: false })
                })
            ],
            onHide: (dialog) => {
                dialog.hide()
                this.setState({ dialogIsOpen: false })
            }
        })
    }

    onDeleteCompareClicked = (listingId) => {
        this.props.listingActions.removeListing('compare', listingId);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.dialogIsOpen && this.props.properties && 
            this.props.properties.ids.length > nextProps.properties.ids.length)
                this.openCompareDialog(nextProps.properties);
    }

    render() {
        const { properties, purlPrefix } = this.props;
        
        if (properties && properties.ids.length){
            let propListings = this.props.listings
            let compareListings = properties.listings.reduce((obj, item) => 
                                    Object.assign(obj, {[item.Id]: item}) ,{});
            let allListings = {...propListings, ...compareListings }
            let compareListingsObjs = properties.ids.map(id => allListings[id])
            return (
                <div className="compare-alert">
                    <div className="compare-content">
                        <div className="compare-header"> You have {properties.ids.length} properties to compare 
                            <div className="compare-button compare-open">
                                <i id="compare_arrow" className="fa fa-arrow-right" onClick={() => this.openCompareDialog(properties)}></i>
                            </div>
                        </div>
                        {
                            compareListingsObjs.map((property, index) => {
                                var imgSrc
                                if (!property.Photos || !property.Photos.length) {
                                    if (property.INDXR)
                                        imgSrc = ImageRewrite(property.INDXR.split('|')[0], true);
                                    else
                                        imgSrc = NoPropertyPhoto;
                                }
                                else 
                                    imgSrc = ImageRewrite(property.Photos[0], true);
                                var FA = `${property.SA} ${property.CT}, ${property.ST} ${property.PC}`;
                                return (
                                    <div key={index} className="compare-property">
                                        <Link to={`${purlPrefix.url}/propertydetail/` + property.Id + '/' + (property.SA ? property.SA.split(' ').join('-') : property.MN) + (property.CT ? '_' + property.CT.split(' ').join('-') : '') + (property.ST ? '_' + property.ST.split(' ').join('-') : '') + (property.PC ? '_' + property.PC.split(' ').join('-') : '')} >
                                            <img src={ imgSrc } alt={FA} className="compare-img" />
                                        </Link>
                                        <div className="compare-button compare-delete">
                                            {/* <i className="fa fa-times"onClick={() => this.onDeleteCompareClicked(property.Id)}></i> */}
                                            <i id="close_property_bt" className="icon-xoutproperty"onClick={() => this.onDeleteCompareClicked(property.Id)}></i>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                    <Dialog ref='dialogRef' />
                </div>
            );
        }
        return (null)
    }
}

const mapStateToProps = (state, props) => ({
    properties: state.listings.compare,
    listings: state.entities.listings,
    purlPrefix: state.session.purlPrefix || { url: ''}
})

const mapDispatchToProps = dispatch => ({
    listingActions: bindActionCreators(listingActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesCompareAlert);